import React from "react";
import { Helmet } from "react-helmet-async";
import { inject } from "mobx-react";
import loadable from "@loadable/component";
import { pipe } from "Utils/functionalUtils";
import { FooterContainerV2 } from "Containers/Footer";
import Header404 from "Containers/Header404";
import WhatsappSendMessageContainer from "Containers/WhatsApp/WhatsappSendMessageContainer";
import { isMainSiteCode } from "Utils/siteConfig";

const OurModal = loadable(() => import("ComponentsUI/OurModal"), {
	ssr: false,
});
const OurModalAgreement = loadable(() => import("ComponentsUI/OurModalAgreement"), {
	ssr: false,
});
const FixedHeader = loadable(() => import("Containers/FixedHeaderContainer"), {
	ssr: false,
});

const Layout404 = (props) => {
	const siteCode = props.ApplicationModel.siteCode;
	return (
		<>
			<Helmet>
				<meta
					name="description"
					content={"Ошибка 404 — к сожалению, такой страницы нет на нашем сайте."}
				/>
				<meta name="keywords" content={""} />
				<title>{"Страница не найдена"}</title>
			</Helmet>
			{isMainSiteCode(siteCode) && <div></div>}
			<WhatsappSendMessageContainer
				whatsappType="page_404"
				whatsappSettings={props.ApplicationModel.siteConfig.settings.whatsapp_send_message}
			/>
			<div id="forSelectField" />
			<Header404 />
			<FooterContainerV2 phone404={true} is404Layout={true} />
			<OurModal />
			<OurModalAgreement />
			<FixedHeader phone404={true} />
		</>
	);
};

export default pipe(inject("ApplicationModel"))(Layout404);
